import { SVGProps } from './SVGProps';

const Twitter = ({ fill = 'white', width = '18', height = '18' }: SVGProps) => {
  return (
    // <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     d="M315 138.824C305.467 143.168 295.191 146.022 284.544 147.388C295.439 140.809 303.858 130.384 307.819 117.848C297.544 124.054 286.153 128.398 274.144 130.88C264.364 120.206 250.621 114 235.022 114C205.928 114 182.157 137.831 182.157 167.246C182.157 171.466 182.652 175.562 183.519 179.41C139.445 177.176 100.198 155.952 74.0755 123.805C69.4947 131.625 66.8948 140.809 66.8948 150.491C66.8948 168.984 76.1802 185.368 90.5416 194.676C81.7514 194.676 73.5803 192.194 66.3996 188.471V188.843C66.3996 214.659 84.7228 236.256 108.989 241.096C101.198 243.234 93.0189 243.531 85.0942 241.965C88.4568 252.546 95.0424 261.804 103.925 268.439C112.808 275.073 123.541 278.75 134.616 278.952C115.843 293.852 92.5719 301.906 68.6281 301.79C64.4187 301.79 60.2094 301.542 56 301.045C79.5229 316.188 107.503 325 137.464 325C235.022 325 288.63 243.827 288.63 173.452C288.63 171.094 288.63 168.86 288.506 166.502C298.905 159.055 307.819 149.622 315 138.824Z"
    //     fill={fill}
    //   />
    // </svg>
    <svg width={width} height={height} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_84_5640)">
        <path
          d="M459.4 151.7C459.7 156.2 459.7 160.8 459.7 165.3C459.7 304 354.1 463.9 161.1 463.9C101.6 463.9 46.4 446.7 0 416.8C8.4 417.8 16.6 418.1 25.3 418.1C74.4 418.1 119.5 401.5 155.6 373.3C109.5 372.3 70.8 342.1 57.5 300.5C64 301.5 70.5 302.1 77.3 302.1C86.7 302.1 96.1 300.8 104.9 298.5C56.8 288.8 20.8 246.5 20.8 195.5V194.2C34.8 202 51 206.9 68.2 207.5C39.9 188.7 21.4 156.5 21.4 120.1C21.4 100.6 26.6 82.7 35.7 67.1C87.4 130.8 165 172.4 252.1 176.9C250.5 169.1 249.5 161 249.5 152.9C249.5 95.1 296.3 48 354.4 48C384.6 48 411.9 60.7 431.1 81.1C454.8 76.6 477.6 67.8 497.7 55.8C489.9 80.2 473.3 100.6 451.6 113.6C472.7 111.3 493.2 105.5 512 97.4C497.7 118.2 479.8 136.7 459.4 151.7Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_84_5640">
          <rect width="512" height="512" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Twitter;
